var map = {
	"./lazylocal/1.jpg": "M9Eh",
	"./lazylocal/2.jpg": "txr+",
	"./lazylocal/3.jpg": "nVht",
	"./lazylocal/4.jpg": "HLmj",
	"./lazylocal/5.jpg": "FbJI",
	"./lazylocal/6.jpg": "Ajj5",
	"./lazylocal/7.jpg": "TG/b",
	"./lazylocal/8.jpg": "Z3CU",
	"./venuemob/1.jpg": "+Nbp",
	"./venuemob/10.jpg": "UmYM",
	"./venuemob/11.jpg": "Ese9",
	"./venuemob/12.jpg": "g06p",
	"./venuemob/13.jpg": "G9li",
	"./venuemob/14.jpg": "/DLh",
	"./venuemob/15.jpg": "qQ5M",
	"./venuemob/2.jpg": "KaYu",
	"./venuemob/3.jpg": "GOg3",
	"./venuemob/4.jpg": "qFkT",
	"./venuemob/6.jpg": "Ydms",
	"./venuemob/7.jpg": "4aXR",
	"./venuemob/8.jpg": "xgSi",
	"./venuemob/9.jpg": "EWoM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TDS5";